import LoadingControls from './loading-controls.component';

interface LoadingPreviewProps {
  message: string;
}

const LoadingPreview = ({ message }: LoadingPreviewProps) => {
  return (
    <div data-cy="loading-preview" className="bt-mt-4 bt-text-gray-1">
      <LoadingControls className="bt-mb-2" />
      <div data-cy="loading-preview-message">{message}</div>
    </div>
  );
};

export default LoadingPreview;
